<template>
  <div class="upi-prefix">
    <h6 class="title">Configure UPI</h6>
    <p>Choose unique text that you want in your UPI IDs</p>

    <md-field :class="{'input-error': $v.upiPrefix.$error || formErrors.upi_prefix.length}">
      <label>UPI Prefix</label>
      <md-input v-model="upiPrefix" @blur="$v.upiPrefix.$touch()" @keyup.enter="createPrefix"
                :ref="'UpiPrefix'" />
    </md-field>
    <h6 class="error-message" v-if="$v.upiPrefix.$error && !$v.upiPrefix.required">Please enter UPI prefix</h6>
    <h6 class="error-message" v-else-if="$v.upiPrefix.$error && !$v.upiPrefix.vpaPrefix">Prefix should contain only lowercase alphabets and should not start with hypto</h6>
    <error-info v-else :errorList="formErrors.upi_prefix" />

    <div class="button-row">
      <button class="primary-btn" @click="createPrefix">Submit</button>
    </div>
  </div>
</template>

<script>
import ErrorInfo from '@/components/global/ErrorInfo'

import ApiServices from '@/services/api/upi'
import { required } from 'vuelidate/lib/validators'
import { vpaPrefix } from '@/utils/helpers/validators'
import { checkFormErrors } from '@/utils/helpers'

export default {
  name: 'SetUpiPrefix',
  components: { ErrorInfo },
  data () {
    return {
      upiPrefix: null,
      formErrors: {
        upi_prefix: []
      }
    }
  },
  validations: {
    upiPrefix: {
      required,
      vpaPrefix
    }
  },
  watch: {
    upiPrefix () {
      this.formErrors.upi_prefix = []
    }
  },
  mounted () {
    this.$refs.UpiPrefix.$el.focus()
  },
  methods: {
    checkFormErrors,
    createPrefix () {
      this.$v.$touch()
      if (!this.$v.$error && !this.checkFormErrors(this.formErrors)) {
        ApiServices.createUpiPrefix({prefix: this.upiPrefix}).then((response) => {
          if (response.success) {
            this.successToastMsg(response.message)
            this.$emit('refreshList')
          } else {
            this.errorToastMsg(response.message)
          }
        }).catch((error) => {
          let data = error.body
          if (typeof data.reason === 'object') {
            this.formErrors = data.reason
          } else {
            this.formErrors.upi_prefix = [data.reason || data.message]
          }
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '@/assets/scss/mixins.scss';

  .upi-prefix {
    background: $white;
    border-radius: 15px;

    .title {
      @include highlight-text($secondary, 15px);
      text-align: left;
    }
    p {
      @include normal-text($secondary, 14px, 400);
      text-align: left;
      margin-top: 10px;
    }
  }

  .desktop {
    .upi-prefix {
      width: 50%;
      padding: 25px;
      height: calc(100vh - 100px);
    }

    .button-row {
      text-align: right;
    }
  }

  .mobile, .tablet {
    .upi-prefix {
      padding: 15px;
    }
  }
</style>
